import { render, staticRenderFns } from "./TroubleServiceTab.vue?vue&type=template&id=8cf98322&"
import script from "./TroubleServiceTab.vue?vue&type=script&lang=ts&"
export * from "./TroubleServiceTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf98322')) {
      api.createRecord('8cf98322', component.options)
    } else {
      api.reload('8cf98322', component.options)
    }
    module.hot.accept("./TroubleServiceTab.vue?vue&type=template&id=8cf98322&", function () {
      api.rerender('8cf98322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/TroubleServiceTab.vue"
export default component.exports